import React, { ReactElement } from 'react'
import { IStep5Props } from '../../interfaces/Step'
import Step5Nif from './Step5Nif'
import Step5NationaliteAmericaine from './Step5NationaliteAmericaine'
import Step5ResidenceFiscale from './Step5ResidenceFiscale'
import { AUTRE, STATUS } from '../../enums/common'
import Spinner from '../Spinner'
import Step5SituationMonegasque from './Step5SituationMonegasque'
import { deleteIcon } from '../../assets/images/images'
import { getItemSuffix } from '../../utils/getItemSuffix'
import { getCountriesValues } from '../../services/utils'
import { Monaco, ResidesFrenchColonies } from './Options'

const Step5Form = (props: IStep5Props): ReactElement => {
  const {
    step,
    item,
    setShowSecondForm,
    stepUploadFileProps,
    form,
    state,
    addState,
    removeState,
    fiscalCountriesList,
    folderData,
    addressStatus,
    countriesStatus,
    address,
  } = props

  const { register, errors, watch } = form
  const fiscalAddressCountrySuffix = `fiscal_address_country${getItemSuffix(
    item
  )}`
  const situationMonegasqueSuffix = `situation_monegasque${getItemSuffix(item)}`
  const fiscal_address_country = folderData[fiscalAddressCountrySuffix]
  const watchFiscalAddressCountry: string = watch(
    fiscalAddressCountrySuffix,
    fiscal_address_country
  )
  const monacoCountryCode = getCountriesValues(Monaco)
  const showMonaco = monacoCountryCode.includes(watchFiscalAddressCountry)
  const residesFrenchColoniesCountryCodes = getCountriesValues(
    ResidesFrenchColonies
  )
  const fiscalAddressCountryAutre = watchFiscalAddressCountry === AUTRE
  const showResidesFrenchColonies = residesFrenchColoniesCountryCodes.includes(
    watchFiscalAddressCountry
  )
  const showNif =
    showMonaco || showResidesFrenchColonies || fiscalAddressCountryAutre

  if (addressStatus === STATUS.pending || countriesStatus !== STATUS.loaded) {
    return (
      <div className="col12 mt1 dFlex alignItemsCenter justifyContentStart">
        <div className="relative pb3 pl3">
          <Spinner small={true} />
        </div>
      </div>
    )
  }

  return (
    <div className="card my4">
      <div className="cardContent cardSmContent px25 py25 relative">
        <h2 className="textPrimary textUppercase fontSizeDefault mb3">
          Résidence fiscale {item ? `N°${item}` : ''}
        </h2>
        <div className="dFlex justifyContentBetween alignItemsCenter">
          {item === 2 && (
            <span
              className="delete-button pointer dInlineBlock py15 px2 btnUnstyled mb15 absolute"
              onClick={() => {
                if (setShowSecondForm) {
                  setShowSecondForm(false)
                  removeState(1)
                }
              }}
            >
              <img src={deleteIcon} alt="deleteCard" className="dBlock" />
            </span>
          )}
        </div>
        <div className="row">
          <Step5ResidenceFiscale
            {...{
              fiscalCountriesList,
              form,
              folderData,
              stepUploadFileProps,
              step,
              address,
              item,
              state,
              addState,
              removeState,
            }}
          />
          {showMonaco && (
            <Step5SituationMonegasque
              error={errors[situationMonegasqueSuffix]}
              register={register({ required: true })}
              item={item}
            />
          )}
          {showNif && (
            <Step5Nif
              {...{
                form,
                folderData,
                item,
              }}
            />
          )}
          {item !== 2 && (
            <Step5NationaliteAmericaine
              {...{
                addState,
                removeState,
                form,
                folderData,
                stepUploadFileProps,
                state,
                step,
                item,
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Step5Form
